import { AppData, Lightning, Log, Registry, Utils } from "@lightningjs/sdk";
import AppModel from "../lib/models/app-model";
import { AppSetup } from "../lib/app-setup";
import { ItemNode } from "../lib/components/grid/ItemNode";
import { Control, Badge, FocusManager, ProgressBar, Row, TextBox } from "@lightningjs/ui-components";
import ControlIcon from "../ui-elements/control-icon";
import { FTPlayerOptions, FTStreamingPlayer } from "../lib/components/ft-streaming-player";
import { ContentPlayer } from "../lib/components/ft-streaming-player/content-player";
import { events as ftEvents } from "../lib/components/ft-streaming-player/utils";
import { Platform } from "../platforms/platform";
import { fetchData, getDRMSERVICEURL, getDRMURL } from "../lib/models/data-service";
import { Helper } from "../lib/helper";
import { Logger } from "../lib/logger";
import { DRM_TYPE, PLAYERSTATE } from "../lib/enum";
import { KeyCodes } from "../lib/key-codes";
import FTTrickPlayUI from "../lib/components/ft-trickplay/ft-trickplay-ui";
import VideoPlaylistUI from "../ui-elements/video-playlist";
import { Router } from "@lightningjs/sdk";
import PlayerInfoUI from "../ui-elements/player-info-ui";
import VideoCCSection from "../ui-elements/video-cc-section";
import CCSettingsOverlay from "../ui-elements/cc-settings-overlay";
import { AppApiConfig } from "../lib/app-api-config";
import LableButton from "../ui-elements/lable-button";
import StarUI from "../ui-elements/star-ui";
import { Config } from "../lib/config";
import VideoMetadataUI from "../ui-elements/video-metadata-ui";
import WatchNextThumbnail from "../ui-elements/watch-next-thumb";

export interface VideoScreenTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}

export interface VideoScreenTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    Container: {
        ControlWrapper: {
            Gradient: {
                TopShader: {}
                BottomShader: {}
            }
            Logo: {}
            Title: {}
            Controls: {
                Progressbar: {
                    Progress: {}
                },
                SpeedText: {}
            },
        },
        SkipTitles: {},
        ItemInfo: {}
        CCSettingsOverlay: typeof CCSettingsOverlay
    }
}

export interface Theme {
    ageRatingColor: string;
    titleColor: string;
    textSize: number;
    textcolor: string;
    gridfocuscolor: string;
    bgcolor: string;
}

export default class VideoScreen extends Lightning.Component<VideoScreenTemplateSpec, VideoScreenTypeConfig> implements Lightning.Component<VideoScreenTemplateSpec> {

    videoInfo!: ItemNode

    videoEl!: HTMLVideoElement | null
    videoElWrapper!: HTMLElement | null
    platform!: Platform
    ftStreamingPlayer!: FTStreamingPlayer
    currentTimeExit = 0
    srcObj: any
    isDRM = false
    isHLS = false
    isMP4 = false
    videoUrl = ''
    playerState: PLAYERSTATE = PLAYERSTATE.NONE
    _index = 2
    buttonIndexMapper!: any
    controllerOn: any;
    controlHideIntv: any
    FocusElement: undefined
    seekMultiplier: number = 0;
    ffRwdSpeed: any = [0, 1, 2, 3, 4, 8, 16];
    finalSeekJumpValue: any;
    ffRewTimerId: any
    rows: number = 3;
    _rowIndex: number = 1;
    resumeTime: number = 0;
    showCC = false;
    args: any;
    showSkip = false;
    enableSkip = false;
    checkOnce = false;
    isDisconnected = false
    isPausedOnAd = false;
    isPlaybackStartEventSent = false
    retries = 0;
    maxRetries = 1;
    hideControlsOnPlayNext = false;
    watchNextTimeOut: any;
    watchNextTimerStarted = false;
    creditsWatched = false;
    focusInfo: any = {}
    focusedRowIndex = 0;
    nextItemImageUrl: any;
    preloadNextItemTimer: number | null = null;
    isNavigatingToNextVideo: boolean = false;
    _theme: Theme = {};
    subtitlePopupTimeoutId: any = null;
    isLoadingBannerVisible: boolean = false;
    errorNextItemTimer: number | null = null;

    override set params(args: any) {
        this.args = args;
    }

    static override _template(): Lightning.Component.Template<VideoScreenTemplateSpec> {
        const { appConfig, appState } = AppData as AppSetup
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        return {
            Container: {
                w: 1920,
                h: 1080,
                collision: true,
                VideoCCSection: {
                    x: 0,
                    y: 0,
                    w: (w: any) => w,
                    h: (h: any) => h,
                    type: VideoCCSection,
                },
                VideoCCOnOffText: {
                    x: (w) => w / 2,
                    y: (h) => h - 260,
                    mountX: 0.5,
                    text: { text: '', fontSize: 42, fontFace: Helper.getFontFamily('Black'), textColor: 0xffff0000 }
                },
                ItemInfo: {
                    w: (w: any) => w,
                    h: (h: any) => h,
                    type: PlayerInfoUI
                },
                CCSettingsOverlay: {
                    type: CCSettingsOverlay,
                    zIndex: 40,
                    visible: false,
                    alpha: 0
                },
                ControlWrapper: {
                    w: 1920,
                    h: 1080,
                    alpha: 0,
                    collision: true,
                    Gradient: {
                        w: (w) => w,
                        h: (h) => h,
                        TopShader: {
                            w: (w) => w,
                            h: (h) => h * 0.2,
                            rect: true,
                            colorTop: 0x9f0e0e1e,
                            colorBottom: 0x000e0e1e,
                        },
                        BottomShader: {
                            y: (h) => h,
                            w: (w) => w,
                            h: (h) => h * 0.3,
                            mountY: 1,
                            rect: true,
                            colorTop: 0x000e0e1e,
                            colorBottom: 0x9f0e0e1e,
                        },
                    },
                    TitleContainer: {
                        x: 200,
                        y: 0,
                        collision: true,
                        BackButton: {
                            collision: true,
                            x: -66,
                            y: 92,
                            alpha: 0.7,
                            texture: {
                                src: Utils.asset('images/ico-back.png'),
                                resizeMode: {
                                    h: 40,
                                    w: 40,
                                    type: 'contain',
                                },
                                type: Lightning.textures.ImageTexture
                            }
                        },
                        Logo: { y: 80 },
                        ItemMetadataWrapper: {
                            y: 152,
                            // flex: { direction: 'column', wrap: false },
                            // children: []
                            type: VideoMetadataUI,
                        },
                    },
                    Controls: {
                        y: (h) => h - 300,
                        w: (w) => w,
                        h: 300,
                        // mountY: 1,
                        flex: { margin: 0, justifyContent: 'center', alignItems: 'center' },
                        ProgressWrapper: {
                            w: (w) => w - 400,
                            forceZIndexContext: true,
                            // h: 72,
                            flex: { margin: 0, direction: 'column', padding: 0, justifyContent: 'center', alignItems: 'center' },
                            TimeWrapper: {
                                y: 5,
                                w: (w: number) => w,
                                h: 40,
                                mount: 0,
                                zIndex: 1,
                                flex: { justifyContent: 'flex-end', alignItems: 'center' },
                                CurrTime: {
                                    h: 40,
                                    text: { text: '00:00:00', fontSize: 25, fontFace: Helper.getFontFamily('Black') }
                                },
                                Line: {
                                    rect: true,
                                    w: 4,
                                    h: 30,
                                    color: 0xffffffff,
                                    flexItem: { marginLeft: 10, marginRight: 10, alignSelf: 'center' },
                                },
                                DurationTime: {
                                    h: 40,
                                    text: { text: '00:00:00', fontSize: 25, fontFace: Helper.getFontFamily('Black') }
                                }
                            },
                            ProgressBarInteraction: {
                                y: 50,
                                w: 1920 - 400,
                                h: 16,
                                zIndex:2,
                                flexItem:false,
                                rect:true,
                                color: 0x00000000,
                                visible: appConfig?.appEnv == 'auto' ? true : false,
                                ProgressDragIcon :{
                                    x:0,
                                    y:5,
                                    rect:true,
                                    color: Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)
                                    mount:0.5,
                                    collision: true,
                                    w: 30,
                                    h: 30,
                                    shader: {
                                        type: Lightning.shaders.RoundedRectangle,
                                        radius: 15,
                                        stroke: 0,
                                    }
                                }
                            },
                            Progressbar: {
                                y: 10,
                                w: 1920 - 400,
                                zIndex:1,
                                type: ProgressBar,
                                progress: 0,
                                animation:null,
                                style: {
                                    height: 10,
                                    // barColor: Helper.getHexaColor('#ffffff', 0.7),
                                    // progressColor: 0xffff0505,
                                    radius: 0
                                }
                            },
                            MediaButtons: {
                                flexItem: { marginRight: 0 },
                                y: 50,
                                w: (w) => w,
                                h: 50,
                                type: FocusManager,
                                collision: true,
                                direction: 'row',
                                items: []
                            },
                        },
                        SpeedText: {
                            mount: 0,
                            x: (w: any) => w - 370,
                            y: (h: any) => h - 250,
                            w: 350,
                            h: 50,
                            rect: true,
                            color: 0x88000000,
                            flexItem: false,
                            shader: { type: Lightning.shaders.RoundedRectangle },
                            flex: {
                                direction: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                // padding: 10,
                            },
                            Text: {
                                y: 2,
                                text: {
                                    text: "Testing",
                                    textColor: 0xffffffff,
                                    fontFace: Helper.getFontFamily('Light'),
                                    fontSize: 32,
                                    fontStyle: "bold",
                                    textAlign: "center",
                                },
                            },
                            visible: false,
                        }
                    },

                },
                SkipTitles: {
                    /*w:300,
                    h:150,
                    type:Button,
                    label:"SKIP INTRO",
                    action:'$skipAction',*/
                    type: LableButton,
                    action: "$skipAction",
                    label: "Skip Intro",
                    fontSize: 32,
                    w: 220,
                    h: 70,
                    //x: (w) => w-400,
                    x: (w) => 200,
                    y: (h) => h - 270,
                    collision: true,
                    visible: false
                },
                WatchNextThumb: {
                    w: 300,
                    h: 220,
                    x: (w) => w - 500,
                    y: (h) => h - 530,
                    type: WatchNextThumbnail,
                    action: "$watchNextAction",
                    // signal: { progressAnimFinished: true },
                    label: 'WATCH NEXT ▶',
                    collision: true,
                    visible: false,
                },
                VideoPlayList: {
                    w: (w: any) => w,
                    h: (h: any) => h,
                    collision: true,
                    type: VideoPlaylistUI,
                    visible: true,
                },
                FTTrickPlayUI: {
                    x: 0,
                    y: 0,
                    w: (w: any) => w,
                    h: (h: any) => h,
                    visible: true,
                    type: FTTrickPlayUI,
                }
            }
        }
    }

    override _setup() {
        const { appState, platform } = AppData as AppSetup;
        const app: AppModel = appState?.getApp()!;
        app.videoObj = this;

        //this.tag("FTPlayer").resetAll()
        appState.player.currentUserAction = ''
        let videoInfo = app.navigation.getCurrentVodInfo();
        this.videoInfo = videoInfo;
        this.platform = platform!
        this.showCC = appState.showSubtitle //setting initial state of the cc
        this.currentTimeExit = 0
    }

    override _init() {
        const { appState } = AppData as AppSetup;
        this.retries = 0;
        const app = appState?.getApp();
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        this._theme.ageRatingColor = `0xff${appApiConfig?.appConfig?.ageRatingColor}` || '0xffffffff'
        const textfocuscolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)
        this.setPlayerState(PLAYERSTATE.NONE)
        //this.tag('Title').content = this.videoInfo.title
        // this.tag('ItemInfo').item = this.videoInfo
        this.tag('VideoCCOnOffText').patch({ textColor: textfocuscolor });
        this.tag("ControlWrapper.TitleContainer").patch({
            Logo: {
                texture: {
                    src: app?.appApiConfig?.appBrandConfig?.header_logo,
                    resizeMode: {
                        h: 60,
                        w: 460,
                        type: 'contain',
                    },
                    type: Lightning.textures.ImageTexture
                },
            },
            ItemMetadataWrapper: {
                item: this.videoInfo
            }
        })
        this.tag('Controls').patch({
            ProgressWrapper: {
                Progressbar: {
                    style: { progressColor: textfocuscolor, barColor: Helper.getHexaColor('#ffffff', 0.22) }
                }
            }
        })
        this._addControlButtons()
        this._setupVideoPlayer()
        this.initTrickplay()
        this.disableCCButton(true)

    }

    initTrickplay() {
        this.tag("FTTrickPlayUI").destroy();
        this.tag("FTTrickPlayUI").initTrickplay(this.videoInfo, this);
    }

    trickplaySelectedHandler(event: any) {
        this.currentTimeExit = event.detail;
        if (event.detail == 0) {
            this.currentTimeExit = 1;
            //this.tag("Controls.ProgressBar").currentTime = this.currentTime;
        }
        this.ftStreamingPlayer.currentTime = this.currentTimeExit;
        Logger.processUserAction('trickplay_selected_' + event.detail, this._getActionKey());
        this._rowIndex = 1;
        this.focusedRowIndex = 1;
        this.ftStreamingPlayer.play();
        this.tag("FTTrickPlayUI").hide();
        this.updateWatchNextThumbPosition();
        this.showController(true);
    }

    trickplayAutoHideHandler(event: any) {
        // this._rowIndex = 1;
        this.focusedRowIndex = 1;
        this.tag('MediaButtons').selectedIndex = 3
        // this._index = this.tag('MediaButtons').selectedIndex
        this.seekMultiplier = 0
        this.stopFFREWTimer()
        this.updatePlayerState()
        this.showController(false)
        this.tag("FTTrickPlayUI").hide();
        this.updateWatchNextThumbPosition();
        this._refocus();
        // XFIN-1270 //
        this.clearControllerTimeout();
        this.controlHideIntv = Registry.setTimeout(() => {
            this.hideController();
        }, 10000);
        // XFIN-1270 //
    }

    override _active() {
        const { appConfig, appState, platform } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig()
        const app = appState?.getApp();
        this.isPausedOnAd = false
        appState.player.videoStartedFromResumePoint = 0;
        appState.player.pausedTime = 0;
        this.isDisconnected = false
        this.isPlaybackStartEventSent = false
        this.showHideVideoLoading(true)
        let resumeTime: any
        if (this.args.id && this.args.id.indexOf("_resume") > -1) {
            if (appConfig?.useLocalStorage == true) {
                resumeTime = localStorage.getItem(this.videoInfo.node_id);
            } else {
                resumeTime = Helper.getCookie(this.videoInfo.node_id);
            }
            if (resumeTime !== "" && resumeTime !== null && resumeTime !== 0 && resumeTime !== '0' && (appApiConfig?.appConfig?.resumeVidMinDuration && this.videoInfo.runtime > appApiConfig?.appConfig?.resumeVidMinDuration)) {
                this.resumeTime = parseInt(resumeTime);
                appState.player.videoStartedFromResumePoint = parseInt(resumeTime);
            }
        } else if (this.args.id && this.args.id.indexOf("_search") > -1) {
            this.resumeTime = app.navigation.getCurrentPlayingTime();
            appState.player.videoStartedFromResumePoint = parseInt(this.resumeTime);
        }

        let ads = app?.ads;
        appState.gridMode = false;
        appState.videoMode = true;

        //this condition is added not to register the video duration when returned from search for the same video
        if (this.args.id.indexOf("_search") == -1) {
            appState.player.noVideosStarted++;
            ads.preRollRequestMade = false;
            let previousVodInfo = app.navigation.getPreviousVideoInfo();
            if (previousVodInfo) {
                //if (previousVodInfo.vodInfo.node_id !== this.videoInfo.node_id) { // this seems to affect the watchduration recording for same video playing from you may like row.
                    Logger.logNextPrevVideoView(this.videoInfo, previousVodInfo);
                //}
            } else {
                //log new video
                Logger.logNewVideoView(this.videoInfo);
            }
        }
        app.navigation.setPreviousVideoInfo(this.videoInfo);
        platform?.sendMetrics('startContent', { vodInfo: this.videoInfo })
        this.checkForAds("preroll", this.resumeTime);
        this.preloadNextItemImage();
    }


    /**
     * @inheritdoc
     * Handles event from device remote media keys & special buttons
     *
     * @param {KeyboardEvent} e
     * @returns {(boolean | void)}
     */
    override _handleKey(e: KeyboardEvent): boolean | void {
        if (this.playerState === PLAYERSTATE.NONE) {
            return;
        }
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        if (appState.eventInProgress) {
            return
        }

        let action: string = '';

        switch (e.keyCode) {
            //media controls key
            case KeyCodes.KEY_FORWARD:
                action = '$forward';
                break;
            case KeyCodes.KEY_REWIND:
                action = '$rewind';
                break;
            case KeyCodes.KEY_NEXT:
                action = '$next';
                break;
            case KeyCodes.KEY_PREVIOUS:
                action = '$previous';
                this._index = this.buttonIndexMapper[action];
                break;
            case KeyCodes.KEY_PLAY:
                action = '$playPause';
                break;
            case KeyCodes.KEY_PAUSE:
                action = '$playPause';
                break;
            case KeyCodes.KEY_OK:
                if (!this.controllerOn) {
                    action = '$playPause';
                } else {
                    return;
                }
                break;
            case KeyCodes.KEY_PLAYPAUSE:
                action = '$playPause';
                break;
            case KeyCodes.KEY_INFO:
                action = '$info';
                break;
            case KeyCodes.KEY_EXIT:
                this.stopFFREWTimer(); // added for the fix XFIN-681
                this.hitCloseTracker();
                app?.handleAppExit()
                return true
            case KeyCodes.KEY_STOP:
                this._handleBack(e);
                return true
            case KeyCodes.KEY_HOME:
                this.stopFFREWTimer(); // added for the fix XFIN-681
                this.hitCloseTracker();
                Logger.processUserAction('userExitedViaRemoteDirectly', this._getActionKey());
                return true

            //navigation keys
            case KeyCodes.KEY_LEFT:
            case KeyCodes.KEY_RIGHT:
                this.showController()
                break;
            default:
                break;
        }

        if (action != '') {
            if (this.controllerOn) {
                this._index = this.buttonIndexMapper[action];
            }
            if (action == '$playPause') {
                this[action](true, true, e.keyCode);  //isUser, isRemote
            } else {
                this[action](true, true);  //isUser, isRemote
            }
        }
    }

    /**
     * Updates the focus information based on the current direction.
     * This method manages the focusable elements in the video player UI
     * and adjusts the focused row index accordingly.
     * @param {string} direction - The direction of focus change ('up' or 'down').
     * 
     */
    updateFocusInfo(direction: string) {
        let trickplayAvailable = this.isTrickplayAvailable()
        let startIndex = -1;
        if (this.enableSkip) {
            if (this.tag('SkipTitles').label === "WATCH CREDITS") {
                this.focusInfo[++startIndex] = "playlist";
                this.focusInfo[++startIndex] = "control";
                this.focusInfo[++startIndex] = "skip";
                this.focusInfo[++startIndex] = "watch_next";
            } else if (this.tag('SkipTitles').label === "SKIP INTRO") {
                this.focusInfo[++startIndex] = "playlist";
                this.focusInfo[++startIndex] = "control";
                this.focusInfo[++startIndex] = "skip";
            }
        } else {
            this.focusInfo[++startIndex] = "playlist";
            this.focusInfo[++startIndex] = "control";
        }
        if (trickplayAvailable) {
            this.focusInfo[++startIndex] = "trickplay";
        }
        this.focusInfo['rowCount'] = startIndex;
        if (direction === 'up') {
            this.focusedRowIndex = this.focusedRowIndex >= this.focusInfo['rowCount'] ? this.focusInfo['rowCount'] : this.focusedRowIndex + 1;
        } else if (direction === 'down') {
            this.focusedRowIndex = this.focusedRowIndex <= 0 ? 0 : this.focusedRowIndex - 1;
        }

    }

    isTrickplayAvailable() {
        const { appConfig } = AppData as AppSetup;
        return !this.tag("FTTrickPlayUI").trickplayError && appConfig?.enableTrickPlay == true
    }

    override _handleUp(e: KeyboardEvent): boolean | void {
        if (this.playerState === PLAYERSTATE.NONE) {
            return;
        }
        Log.info("VideoScreen: _handleUp this._rowIndex : ", this._rowIndex);
        const { appState, appConfig } = AppData as AppSetup
        if (appState.eventInProgress) {
            return
        }
        this.updateFocusInfo('up')
        if (this.controllerOn) {
            this.showController(false);
            this.stopFFREWTimer()
        } else {
            // this._rowIndex = 1
            this.focusedRowIndex = 1
            this.showController()
        }
    }

    override _handleDown(e: KeyboardEvent): boolean | void {
        if (this.playerState === PLAYERSTATE.NONE) {
            return;
        }
        const { appState, appConfig } = AppData as AppSetup
        if (appState.eventInProgress) {
            return
        }
        this.clearControllerTimeout()
        this.tag("FTTrickPlayUI").hide();
        this.updateWatchNextThumbPosition();
        this.updateFocusInfo('down')
        if (this.controllerOn) {
            this.showController(false);
            this.stopFFREWTimer()
        } else {
            this.focusedRowIndex = 1
            this.showController()
        }
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        const { appState, platform } = AppData as AppSetup
        const app = appState?.getApp() as AppModel
        let videoInfo = this.videoInfo;

        // if (platform && !platform.networkManager.isNetworkConnected()) {
        //     app.handleAppExit()
        //     return true;
        // }

        if (this.playerState === PLAYERSTATE.NONE) {
            return;
        }
        if (this.playerState === PLAYERSTATE.PAUSED && this.isPausedOnAd == true && this.screen == "ad") {
            return;
        }
        Log.info("VideoScreen: _handleBack");

        if (this.controllerOn) {
            /** Fix for XFIN-684 - START */
            if (Math.abs(this.seekMultiplier) > 0) {
                this.tag('MediaButtons').selectedIndex = 3
                // this._index = this.tag('MediaButtons').selectedIndex;
                this.$playPause();
                this.focusedRowIndex = 1;
                this.tag("FTTrickPlayUI").hide(); // Hide trickplay UI
            }
            /** Fix for XFIN-684  - END */
            if (videoInfo.endcredit_st && this.getCurrentTime() >= videoInfo.endcredit_st && this.getCurrentTime() <= videoInfo.endcredit_et) {
                this.hideControlsOnPlayNext = true;

                this.clearWatchNextTimer()
                this.tag('WatchNextThumb').visible = false;
                this.creditsWatched = true;
            }
            this.hideController()

            if (e.keyCode == KeyCodes.KEY_STOP) {
                this.handleBackNavigation();
            }
            return;
        } else {
            // this.closeVideo()
            this.clearWatchNextTimer()
            this.handleBackNavigation();
            return;
        }
    }

    /**
     * @method showHideVideoLoading
     * @description Shows or hides the video loading banner
     * @param {boolean} state - true to show, false to hide
     * 
     */
    showHideVideoLoading(state: boolean) {
        this.widgets.loadingscreen.showVideoLoadingScreen(state)
        // Hide and destroy Trickplay UI when loading banner is shown
        this.isLoadingBannerVisible = state;
        if (state) {
            this.tag("FTTrickPlayUI").hide();
        }
    }

    getDrmProxyObj = (videoInfo: any) => {
        return new Promise((resolve, reject) => {
            if (videoInfo.drm == 1) {
                const drm = {
                    "com.widevine.alpha": {
                        serverURL: getDRMSERVICEURL(DRM_TYPE.WIDEVINE),
                        audioRobustness: 'SW_SECURE_CRYPTO',
                        videoRobustness: 'SW_SECURE_DECODE',
                        priority: 0,
                    },
                    "com.microsoft.playready": {
                        serverURL: getDRMSERVICEURL(DRM_TYPE.PLAYREADY),
                        audioRobustness: 'SW_SECURE_CRYPTO',
                        videoRobustness: 'SW_SECURE_DECODE',
                        priority: 1,
                    },
                };
                resolve(drm);
            } else {
                resolve(null);
            }
        })
    }

    getDrmObj = (videoInfo: any) => {
        const { appConfig } = AppData as AppSetup;
        var promise = new Promise((resolve, reject) => {
            if (videoInfo.drm == 1) {
                const url = getDRMURL();
                fetchData(url).then((response: any) => {
                    if (response && response.data) {
                        const drm = {
                            "com.widevine.alpha": {
                                serverURL: appConfig?.drmInfo.widevineLisenceUrl,
                                httpRequestHeaders: {
                                    customdata: response.data.customdata,
                                },
                                audioRobustness: 'SW_SECURE_CRYPTO',
                                videoRobustness: 'SW_SECURE_DECODE',
                                priority: 0,
                            },
                            "com.microsoft.playready": {
                                serverURL: appConfig?.drmInfo.playreadyLisenceUrl,
                                httpRequestHeaders: {
                                    customdata: response.data.customdata,
                                },
                                audioRobustness: 'SW_SECURE_CRYPTO',
                                videoRobustness: 'SW_SECURE_DECODE',
                                priority: 1,
                            },
                        };
                        resolve(drm);
                    } else {
                        resolve(null);
                    }
                });
            } else {
                resolve(null);
            }
        });
        return promise;
    };

    hitCloseTracker() {
        const { appState } = AppData as AppSetup;
        const app: AppModel = appState?.getApp()!;
        let previousVodInfo = app.navigation.getPreviousVideoInfo();
        if (!previousVodInfo) {
            return;
        }
        let curTime = Math.round(this.currentTimeExit);
        app.navigation.setPreviousVideoWatchDuration(curTime)
        Logger.logCloseVideoView(app.navigation.getPreviousVideoInfo())
        app.navigation.resetPreviousVideoInfo()
    }

    sendMetricsOnEnd() {
        const { platform } = AppData as AppSetup;
        const isCompleted = (this.currentTimeExit >= this.videoInfo.runtime - 240) ? true : false
        platform?.sendMetrics('stopContent', { vodInfo: this.videoInfo, watchedDuration: this.currentTimeExit, completed: isCompleted, totalDuration: this.videoInfo.runtime })
    }


    /**
     * Close video - will be triggered when the user wantes to go back to grid or launch search from player.
     * @param {boolean} [hitCloseTracker=false] - this param will be set as true, when the search button is triggered from player.
     */
    closeVideo(skipCloseTracker = false) {
        if (!skipCloseTracker) {
            this.hitCloseTracker()
            this.sendMetricsOnEnd()
        }
        this.focusedRowIndex = 1;
        this._rowIndex = 1;
        this.stopFFREWTimer(); // added for the fix XFIN-681
        this.tag("FTTrickPlayUI").hide(); // IPTV-2411 - Hide trickplay UI explicitly
        this.resetAds() // added for the fix XFIN-681 resetting the ads on exiting the player screen.
        this.resetPlayer()
    }

    resetPlayer() {
        this.tag('VideoCCSection').removeCaption() // XFIN-677 - clearing the captions first and then reset the player.
        this._removeEventListener()
        this.ftStreamingPlayer.destroy()
        this.setPlayerState(PLAYERSTATE.NONE)
        this.hideVideo()
    }

    updatePlayerState() {
        const playerState = this.videoEl?.paused || this.videoEl?.ended ? PLAYERSTATE.PAUSED : PLAYERSTATE.PLAYING
        this.setPlayerState(playerState)
    }

    setPlayerState(playerState: PLAYERSTATE) {
        const { appState } = AppData as AppSetup
        if (playerState == PLAYERSTATE.READY) {
            appState.eventInProgress = false;
            this.showHideVideoLoading(false)
            if (!this.videoInfo.runtime) {
                this.videoInfo.runtime = Math.round(this.videoEl?.duration)
            }
        } else if (this.playerState == PLAYERSTATE.FF || this.playerState == PLAYERSTATE.REW) {
            //XFIN-726, adding this condition when the previous stat is still in ff/rew only set focus on FF or Rew button
            // this happens when the remote ff/rew is called appropriote button is set.
            if (playerState == PLAYERSTATE.FF) {
                this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 0
                this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$forward']
            } else if (playerState == PLAYERSTATE.REW) {
                this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 0
                this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$rewind']
            }
        } else if (playerState == PLAYERSTATE.PLAYING) {
            this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 1
            this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$playPause']
        } else if (playerState == PLAYERSTATE.PAUSED) {
            this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 0
            this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$playPause']
        } else if (playerState == PLAYERSTATE.FF) {
            this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 0
            this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$forward']
        } else if (playerState == PLAYERSTATE.REW) {
            this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 0
            this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$rewind']
        }
        this.playerState = playerState //assign the new playlist
    }

    async _resumePlayer(resumeTime = 0) {
        Log.info("videoInfo ", this.videoInfo);
        const { appConfig } = AppData as AppSetup
        const options = new FTPlayerOptions()
        /**Video Info check */
        this.isDRM = false;
        this.isHLS = false;
        this.isMP4 = false;

        if (this.videoInfo) {
            if (this.videoInfo.drm == 1) {
                this.isDRM = true;
                this.videoUrl = this.videoInfo.video_url;
            } else if (this.videoInfo.video_format == "hls") {
                this.isHLS = true;
                this.videoUrl = this.videoInfo.video_hls_url!;
            } else if (this.videoInfo.video_format == "mp4") {
                this.isMP4 = true;
                this.videoUrl = this.videoInfo.video_url;
            }
        }

        let isDebugPlayer = false;
        Log.info("videoUrl ", this.videoUrl);
        this.setPlayerState(PLAYERSTATE.INITIALIZING)
        //const drm = await Helper.getDrmObj(this.videoInfo)
        let drm
        if (appConfig?.useDRMProxy) {
            drm = await Helper.getDrmProxyObj(this.videoInfo)
        } else {
            drm = await Helper.getDrmObj(this.videoInfo)
        }
        const hlsOptions = this.platform.getHlsOptions()
        Log.info("hlsOptions ", hlsOptions);
        options.dash.drm = drm
        options.startTime = parseInt(resumeTime);
        const mp4Url = { src: this.videoInfo.video_url, type: 'video/mp4', options: options };
        const hlsUrl = { src: this.videoInfo.video_hls_url, type: 'application/vnd.apple.mpegurl', options: options };
        const dashUrl = { src: (this.videoInfo.video_format == "mpd" ? this.videoInfo.video_url : null) || null, type: 'application/dash+xml', options: options };

        let src
        if (dashUrl.src !== null) {
            src = dashUrl
        } else if (hlsUrl.src !== null) {
            options.hls = hlsOptions;
            hlsUrl.src = hlsUrl.src
            src = hlsUrl;
        } else {
            src = mp4Url;
        }
        if (appConfig?.testVideoError) {
            src.src = "https://video_404"
        }

        this._removeEventListener()
        this._setEventListeners()
        this.ftStreamingPlayer.src = src
        this.ftStreamingPlayer.play();
        this.tag('VideoCCSection').addCaption(this.videoInfo.cc_path, this)
        this.showVideo()
        this.showController()
    }

    hideVideo() {
        //VideoPlayer.hide();
        if ($('#content-player-wrapper')) {
            $('#content-player-wrapper').hide()
        }
    }

    showVideo() {
        if ($('#content-player-wrapper')) {
            $('#content-player-wrapper').show()
        }
    }

    showController(autoHide = true) {
        this.clearControllerTimeout()
        if (autoHide) {
            if (!this.enableSkip) {
                this.controlHideIntv = Registry.setTimeout(() => {
                    this.hideController()
                }, 10000)
            }
        }
        this.tag('SkipTitles')?.setSmooth('alpha', 1)
        this.tag('ControlWrapper')?.setSmooth('alpha', 1)
        this.controllerOn = true
        this._refocus()
    }

    clearControllerTimeout() {
        clearTimeout(this.controlHideIntv)
        this.controlHideIntv = undefined
    }

    hideController() {
        this.tag('SkipTitles')?.setSmooth('alpha', 0)
        this.tag('ControlWrapper')?.setSmooth('alpha', 0)
        this.controllerOn = false
        this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$playPause']  // Fix for XFIN-1075
        this._refocus()
    }

    disableCCButton(state: boolean) {
        const { appConfig } = AppData as AppSetup;
        if (appConfig.disableCC) return
        if (!state) {
            this.showHideSubtitleState(this.showCC)
        }
        this.tag('MediaButtons').items[this.buttonIndexMapper['$closedcaption']].skipFocus = state
        this.tag('MediaButtons').items[this.buttonIndexMapper['$closedcaption']]._update()

    }

    showHideSubtitleState(state: boolean) {
        const { appState, appConfig } = AppData as AppSetup;
        if (appConfig.disableCC) {
            this.showCC = false
            appState.showSubtitle = false
            return
        }
        appState.showSubtitle = state
        this.showCC = state
        if (state) {
            this.tag('MediaButtons').items[this.buttonIndexMapper['$closedcaption']].stateIndex = 0
            this.tag("VideoCCSection").controlSubtitleVisibility()

        } else {
            this.tag('MediaButtons').items[this.buttonIndexMapper['$closedcaption']].stateIndex = 1
            this.tag("VideoCCSection").controlSubtitleVisibility()
        }
    }

    _getActionKey() {
        if (this.videoInfo) {
            return `${this.videoInfo.node_id}_${this.currentTimeExit}`
        }
        return ''
    }

    //----------------Video player setup and handling code section.
    _setupVideoPlayer() {
        let el = document.getElementById("content-player");
        let elw = document.getElementById('content-player-wrapper');
        if (!el) {
            elw = document.createElement('div');
            elw.setAttribute('id', 'content-player-wrapper')
            elw.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;background-color: #000;display:none;')
            el = document.createElement("video")
            el.id = 'content-player'
            el.style.width = '100%'
            el.style.height = '100%'
            el.setAttribute("crossorigin", "anonymous");
            el.setAttribute("autoplay", "false");
            elw.appendChild(el)
            let subtitle = document.createElement('div')
            subtitle.id = 'subtitle'
            subtitle.setAttribute('style', 'position: absolute;bottom: 90px;left: 10px;text-align: center;max-width: 1900px;right: 10px;display: none;')
            subtitle.innerHTML = '<span></span>'
            elw.appendChild(el)
            elw.appendChild(subtitle)
            document.body.appendChild(elw)
        }
        this.videoEl = el as HTMLVideoElement
        this.videoElWrapper = elw as HTMLElement
        this.ftStreamingPlayer = FTStreamingPlayer.getInstance(this.videoEl)
        ContentPlayer.getInstance().resetCarouselPreview()
    }

    _setEventListeners() {
        ftEvents.map(event => {
            this.ftStreamingPlayer.addEventListener(event, this._handleFtPlayerEvents)
        })
        this.ftStreamingPlayer.addEventListener('playererror', this._handleFtPlayerEvents)
    }

    _removeEventListener() {
        ftEvents.map(event => {
            this.ftStreamingPlayer.removeEventListener(event, this._handleFtPlayerEvents)
        })
        this.ftStreamingPlayer.removeEventListener('playererror', this._handleFtPlayerEvents)
    }

    _handleNetworkChange(errorObj: { error, errType, errorDetailStr } | undefined = undefined) {
        const { appConfig, platform } = AppData as AppSetup;
        let pauseTime = this.currentTimeExit
        platform?.networkManager.healthCheck(true, this, {
            success: (isFailedTriggered: boolean) => {
                if (isFailedTriggered) {
                    this.isDisconnected = false
                    this._resumePlayer(pauseTime)
                } else {
                    if (errorObj) {
                        this.handleNextOrPreviousError(errorObj)
                    }
                }
            }, failed: () => {
                this.trickplayAutoHideHandler(null)
                this.hideController()
                this._setState('')
                this.isDisconnected = true
                this.resetPlayer()
                //this.ftStreamingPlayer.pause()
            }
        })
    }

    _handleFtPlayerEvents = (event: any) => {
        let curTime = Math.round(this.getCurrentTime());
        let durTime = Math.round(this.videoEl.duration);
        const { appConfig } = AppData as AppSetup;
        if (event.type !== 'progress' && event.type !== 'timeupdate') { Log.info('PlayerEvent:', event.type, curTime, durTime) }
        switch (event.type) {
            case 'loadedmetadata':
                this.tag("FTTrickPlayUI").setVideoDuration(durTime);
                this.setPlayerState(PLAYERSTATE.READY)
                break;
            case 'pause':
                this.setPlayerState(PLAYERSTATE.PAUSED)
                break;
            case 'waiting':
                if (appConfig?.enableNetworkDisconnectionCheck == true) {
                    this._handleNetworkChange()
                }
                this.setPlayerState(PLAYERSTATE.PLAYING) // Pause Button should be displayed ony on the pause action not in waiting.
                break;
            case 'playing':
                if (!this.isPlaybackStartEventSent) {
                    Logger.processUserAction('playbackStarted', `${this.videoInfo.node_id}_${this.videoInfo.video_format}`)
                    this.isPlaybackStartEventSent = true
                }
                this.setPlayerState(PLAYERSTATE.PLAYING)
                break;
            case 'ended':
                this.$next()
                break;
            case 'error':
            case 'playererror':
                this.handlePlayerError(event)
                break;
            case 'timeupdate':
                if (this.currentTimeExit == curTime) {
                    return
                }
                if (this.playerState !== PLAYERSTATE.PLAYING) {
                    return
                }

                this.currentTimeExit = curTime
                this._updateProgress(curTime, durTime)
                this.updateVideoResumeTime(curTime, durTime, 'videoprogress');
                this.$videoPlayerTimeUpdate(curTime)

                if (appConfig?.enableTrickPlay) {
                    this.tag("FTTrickPlayUI").setPlayerTime(curTime);
                }

                break;
        }

    }

    getErrorCode(error: any) {
        let code = '';
        try {
            code = error.detail.message.error.code
        } catch (e) {

        }
        return code;
    }

    getErrorMsg(error: any) {
        let msg = '';
        try {
            msg = error.detail.message.error.message
        } catch (e) {

        }
        return msg;
    }

    getErrorXhr(error: any) {
        try {
            return error.detail.message.error.data
        } catch (e) {
            return null
        }
    }

    handlePlayerError(error: CustomEvent) {
        let errType = '';
        let errorDetailStr = '';
        let isFatal = false
        const { appConfig } = AppData as AppSetup;
        try {
            if (error) {
                if (error.detail && error.detail.type) {
                    if (error.detail.type == 'M(PEG)-DASH') {
                        let errorDetail = {
                            type: 'dashError',
                            message: this.getErrorMsg(error),
                            errorCode: this.getErrorCode(error)
                        }
                        errType = 'Dash';
                        errorDetailStr = JSON.stringify(errorDetail);
                        isFatal = true
                    } else if (error.detail.type == "HLS") {
                        errType = error.detail.type;
                        var errorDetail = {
                            type: error.detail.type,
                            message: error.detail.message
                        }
                        errorDetailStr = JSON.stringify(errorDetail);
                        isFatal = error.detail.data[1].fatal
                    } else if (error.detail.type == "MP4") {
                        isFatal = true
                        errType = error.detail.type;
                    }
                }

                if (isFatal) {
                    Logger.processUserAction('playbackfailed', this._getActionKey(), errType, errorDetailStr);
                } else {
                    Logger.processUserAction('videoError', this._getActionKey(), errType, errorDetailStr);
                }

                let errObj = undefined
                if (isFatal) {
                    errObj = { error, errType, errorDetailStr }
                    this.startTimerForHandleFatalError(errObj)
                    // if (appConfig?.enableNetworkDisconnectionCheck == true) {
                    //     this._handleNetworkChange({ error, errType, errorDetailStr })
                    // } else {
                    //     this.handleNextOrPreviousError(errObj)
                    // }
                }

            }
        } catch (e) {
            //console.log('script error:', e)
        }
    }

    startTimerForHandleFatalError(errObj: any) {
        const { appConfig } = AppData as AppSetup;
        clearTimeout(this.errorNextItemTimer)
        this.errorNextItemTimer = setTimeout(()=>{
            if (appConfig?.enableNetworkDisconnectionCheck == true) {
                this._handleNetworkChange(errObj)
            } else {
                this.handleNextOrPreviousError(errObj)
            }
        }, 3000)
    }

    handleNextOrPreviousError(errorObj: { error, errType, errorDetailStr }) {
        const { appConfig, appState, platform } = AppData as AppSetup;
        const { error, errType, errorDetailStr } = errorObj
        Log.info('Video Error: ', error)
        //XFIN-703 -  sendin gthe error metrics to platform which in turn will send the metrics to appropriate device api
        // example for comcast it will send the error metrics to Firebolt.
        platform?.sendMetrics('error', { errorType: 'network', code: errType, description: errorDetailStr })
        if ((appConfig as Config).enableRetries && this.retries < this.maxRetries) {
            this.retries++;
            Log.info('Retrying video playback, retry count: ', this.retries);
            Logger.processUserAction('retryingOnVideoOnError' + errType);
            this.resetPlayer()
            this._resumePlayer(this.currentTimeExit);
            return;
        }
        //dataObj.errorType, dataObj.code, dataObj.description
        if (appState?.player.currentUserAction == 'previous') {
            Logger.processUserAction('autoPlayingPreviousVideoOnError' + errType);
            this.playPreviousVideo()
        } else {
            Logger.processUserAction('autoPlayingNextVideoOnError' + errType);
            this.playNextVideo(true)
        }
    }

    updateVideoResumeTime = (curTime: any, durTime: any, updateOn: any) => {
        const { appConfig, appState } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig()
        if (appConfig?.enableResumeVideo) {
            if (durTime > appApiConfig?.appConfig?.resumeVidMinDuration) {
                if (curTime < (durTime - 240)) {
                    if (updateOn == 'videoprogress') {
                        if (curTime % 10 == 0 && curTime !== 0) {
                            if (appConfig.useLocalStorage == true) {
                                localStorage.setItem(this.videoInfo.node_id, curTime);
                            } else {
                                Helper.setGeneralCookie(this.videoInfo.node_id, curTime, 365);
                            }
                        }
                    } else {
                        if (appConfig.useLocalStorage == true) {
                            localStorage.setItem(this.videoInfo.node_id, curTime);
                        } else {
                            Helper.setGeneralCookie(this.videoInfo.node_id, curTime, 365);
                        }
                    }
                } else {
                    if (appConfig.useLocalStorage == true) {
                        localStorage.removeItem(this.videoInfo.node_id);
                    } else {
                        Helper.removeCookie(this.videoInfo.node_id);
                    }
                }
            }
        }
    }
    //----------------Video player setup and handling code section.

    $playPause(isUserAction = false, isRemote = false, keyCode = 0) {
        this.clearWatchNextTimer();
        if (this.playerState === PLAYERSTATE.PLAYING) {
            this.showController(false);
        } else {
            this.showController(true);
        }
        this.stopFFREWTimer();
        if (Math.abs(this.seekMultiplier) > 0) {
            this.stopFFREWTimer();
            this.tag("FTTrickPlayUI").hide();
            this.updateWatchNextThumbPosition();
            this.currentTimeExit = this.finalSeekJumpValue
            this.seekMultiplier = 0;
            this.setCurrentTime(this.finalSeekJumpValue);
            // if(keyCode == KeyCodes.KEY_PLAYPAUSE || keyCode == KeyCodes.KEY_PLAY) {
            //     this.ftStreamingPlayer.play()
            //     this.setPlayerState(PLAYERSTATE.PLAYING)
            // } else {
            //     this.ftStreamingPlayer.pause()
            //     this.setPlayerState(PLAYERSTATE.PAUSED)
            // }
        }
        let actionToPerform: string = this.playerState == PLAYERSTATE.PLAYING ? 'pause' : 'play'
        if (isUserAction && isRemote) {
            if (keyCode == KeyCodes.KEY_PLAY) {
                actionToPerform = 'play'
            } else if (keyCode == KeyCodes.KEY_PAUSE) {
                actionToPerform = 'pause'
            } else {
                //for Play/Pause button on remote
                actionToPerform = this.playerState == PLAYERSTATE.PLAYING ? 'pause' : 'play';
            }
        }
        if (actionToPerform == 'play') {
            this.ftStreamingPlayer.play();
            this.setPlayerState(PLAYERSTATE.PLAYING)
            this.updateWatchNextThumbPosition();
            this.tag('WatchNextThumb').startProgress();
        } else {
            this.ftStreamingPlayer.pause();
            this.setPlayerState(PLAYERSTATE.PAUSED)
        }

        //this.tag("FTTrickPlayUI").hide();
        Logger.processUserAction('playPausePressedOnVideoPlayer_' + (isUserAction ? 'user' : 'auto'), this._getActionKey());

    }

    $previous(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        let action = isRemote ? 'previousButtonPressedOnRemote' : 'previousVideoButtonPressedOnPlayerUI'
        Logger.processUserAction(action, this._getActionKey);
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.stopFFREWTimer();
        appState.player.pausedTime = 0;
        appState.player.videoStartedFromResumePoint = 0;
        appState.player.currentUserAction = 'previous'
        // let curTime = Math.round(this.currentTimeExit);
        // app.navigation.setPreviousVideoWatchDuration(curTime)
        /** Fix for XFIN-832 - START */
        if (Math.abs(this.seekMultiplier) > 0) {
            this.stopFFREWTimer();
            this.tag("FTTrickPlayUI").hide();
            this.updateWatchNextThumbPosition();
        }
        /** Fix for XFIN-832  - END */
        this.playPreviousVideo()
    }

    $next(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.stopFFREWTimer();
        appState.player.pausedTime = 0;
        appState.player.videoStartedFromResumePoint = 0;

        let action = isRemote ? 'nextButtonPressedOnRemote' : 'nextVideoButtonPressedOnPlayerUI'
        let isautoplay = false
        if (!isUserAction && !isRemote) {
            action = 'autoPlayingNextVideoOnComplete';
            appState.player.noVideosPlayed += 1;
        }
        Logger.processUserAction(action, this._getActionKey());
        appState.player.currentUserAction = 'next'
        // let curTime = Math.round(this.currentTimeExit);
        // app.navigation.setPreviousVideoWatchDuration(curTime)
        /** Fix for XFIN-832 - START */
        if (Math.abs(this.seekMultiplier) > 0) {
            this.stopFFREWTimer();
            this.tag("FTTrickPlayUI").hide();
            this.updateWatchNextThumbPosition();
        }
        /** Fix for XFIN-832  - END */
        this.playNextVideo(isautoplay)
    }

    $hide() {
        this.focusedRowIndex = 1
        this._rowIndex = 1
        this.showController()
    }

    $reset() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.showHideVideoLoading(true)
        this.sendMetricsOnEnd()
        this.ftStreamingPlayer.pause()
        let curTime = Math.round(this.currentTimeExit);
        app.navigation.setPreviousVideoWatchDuration(curTime)
        this.resetAds()
        this.resetPlayer()
    }

    async playPreviousVideo() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let curTime = Math.round(this.currentTimeExit);
        app.navigation.setPreviousVideoWatchDuration(curTime)
        this.showHideVideoLoading(true)
        this.sendMetricsOnEnd()
        this.ftStreamingPlayer.pause()
        this.resetAds()
        this.resetPlayer()
        const vodItem: ItemNode = await app?.getPrevItem()!;
        Log.info("playPrevVideo: ", vodItem);
        appState.player.vodAutoPlayed = false;
        setTimeout(() => {
            if (vodItem.feed_type == "video") {
                Router.navigate("video-screen/" + vodItem.node_id + '_r_' + new Date().getTime(), false);
            }
        }, 300);
    }

    async playNextVideo(isAutoPlayed) {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let curTime = Math.round(this.currentTimeExit);
        app.navigation.setPreviousVideoWatchDuration(curTime)
        this.showHideVideoLoading(true)
        this.sendMetricsOnEnd()
        this.ftStreamingPlayer.pause()
        this.resetAds()
        this.resetPlayer()
        const vodItem: ItemNode = await app?.getNextItem()!;

        Log.info("playNextVideo: ", vodItem);
        appState.player.vodAutoPlayed = isAutoPlayed;
        setTimeout(() => {
            if (vodItem.feed_type == 'video') {
                Router.navigate("video-screen/" + vodItem.node_id + '_r_' + new Date().getTime(), false);
            }
        }, 300);
    }


    /**
     * This function is triggered for ff/rew action where the player is paused
     * and a timmer is started to show the ff/ rew jump progress. till the user changes the ff/rew event.
     */
    startFFREWTimer = () => {
        this.checkOnce = false;
        this.disableSkip();
        const { appConfig } = AppData as AppSetup;
        let timer = 100;
        if (!this.ffRewTimerId) {
            this.ffRewTimerId = setInterval(() => {
                this.forwardRewind();
            }, timer);
            if (appConfig.enableTrickPlay) {
                this.tag("FTTrickPlayUI").show();
                this.updateWatchNextThumbPosition();
            }
        }
    };

    stopFFREWTimer = () => {
        clearInterval(this.ffRewTimerId);
        this.ffRewTimerId = null;
        this.tag('SpeedText').visible = false
        // this.patch({
        //     ControlsWrapper: {
        //         Controls: {
        //             SpeedText: {
        //                 visible: false,
        //             },
        //         },
        //     },
        // });
    };

    forwardRewind = () => {
        const { appConfig } = AppData as AppSetup;
        let multiplier;
        let seekInterval;
        let speed;
        if (this.seekMultiplier > 0) {
            seekInterval = 10;
            speed = this.ffRwdSpeed[this.seekMultiplier];
            multiplier = speed * seekInterval;
        } else if (this.seekMultiplier < 0) {
            seekInterval = 10;
            speed = this.ffRwdSpeed[this.seekMultiplier * -1];
            multiplier = speed * seekInterval * -1;
        } else {
            return;
        }
        this.finalSeekJumpValue = this.finalSeekJumpValue + multiplier;// / 10;
        let videoDuration = this.videoEl.duration;
        var exitAndplay = false;
        if (this.finalSeekJumpValue > videoDuration - 10) {
            this.finalSeekJumpValue = videoDuration - 10;
            exitAndplay = true;
            Logger.processUserAction('playerFastForward_autoStoppingAtVideoEnd');
        } else if (this.finalSeekJumpValue < 0) {
            this.finalSeekJumpValue = 0;
            exitAndplay = true;
            Logger.processUserAction('playerRewind_autoStoppingAtVideoStart');
        }
        let curTime = Math.round(this.finalSeekJumpValue);
        let durTime = Math.round(videoDuration);
        this._updateProgress(curTime, durTime);
        if (appConfig.enableTrickPlay) {
            this.tag("FTTrickPlayUI").setPlayerTime(curTime);
        }
        let time = Helper.secondsToDisplayReadyTime(this.finalSeekJumpValue);
        let timeStrArr = time.split(":");
        let timeStr = `${timeStrArr[0]}h : ${timeStrArr[1]}m : ${timeStrArr[2]}s`;
        let speedTime = `${speed}X : ${timeStr}`;
        this.tag('SpeedText').patch({
            Text: {
                text: {
                    text: speedTime,
                },
            }
        })

        let isVisible = this.tag("SpeedText").visible;
        if (!isVisible) {
            this.tag('SpeedText').visible = true
        }

        if (exitAndplay) {
            //this.tag("FTVideoComponent").seek(this.finalSeekJumpValue);
            this.$playPause();
        }
    };

    $rewind(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        if (this.isLoadingBannerVisible) return; // Block REW
        /** Fix for XFIN-832 - START */
        if (this._rowIndex == 2 || this.focusedRowIndex == 0) {
            return;
        }
        /** Fix for XFIN-832 - END */
        this.showController(false);
        this.tag('WatchNextThumb').visible = false;
        if (this.seekMultiplier == 0) {
            this.finalSeekJumpValue = this.getCurrentTime();//this.currentTime;
        }
        this.ftStreamingPlayer.pause()
        this.setPlayerState(PLAYERSTATE.REW)
        this.startFFREWTimer();
        this.tag('WatchNextThumb').startProgress();
        let maxFFlength = this.ffRwdSpeed.length - 1;
        if (this.seekMultiplier >= 0) {
            this.seekMultiplier = -1;
        } else if (
            this.seekMultiplier < 0 &&
            Math.abs(this.seekMultiplier) <= maxFFlength
        ) {
            this.seekMultiplier =
                Math.abs(this.seekMultiplier) == maxFFlength
                    ? -1
                    : this.seekMultiplier - 1;
        }
        let action = isRemote ? 'rewindButtonPressedOnRemote_' : 'rewindButtonPressedOnPlayerUI_'
        Logger.processUserAction(action + this.ffRwdSpeed[this.seekMultiplier * -1], this._getActionKey());

        // if (!this.tag("FTVideoComponent").paused && !this.tag("FTVideoComponent").ended) {
        //     this.tag("FTVideoComponent").pause();
        // }
    }

    $forward(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        if (this.isLoadingBannerVisible) return; // Block FF
        /** Fix for XFIN-832 - START */
        if (this._rowIndex == 2 || this.focusedRowIndex == 0) {
            return;
        }
        /** Fix for XFIN-832 - END */
        this.showController(false);
        if (this.seekMultiplier == 0) {
            this.finalSeekJumpValue = this.getCurrentTime();//this.currentTime;
        }
        this.ftStreamingPlayer.pause()
        this.setPlayerState(PLAYERSTATE.FF)
        this.startFFREWTimer();
        this.tag('WatchNextThumb').startProgress();
        let maxFFlength = this.ffRwdSpeed.length - 1;
        if (this.seekMultiplier <= 0) {
            this.seekMultiplier = 1;
        } else if (
            this.seekMultiplier > 0 &&
            this.seekMultiplier <= maxFFlength
        ) {
            this.seekMultiplier =
                this.seekMultiplier == maxFFlength ? 1 : this.seekMultiplier + 1;
        }
        //Logger.processUserAction('playerFastForward_' + this.ffRwdSpeed[this.seekMultiplier]);
        let action = isRemote ? 'forwardButtonPressedOnRemote_' : 'forwardButtonPressedOnPlayerUI_'
        Logger.processUserAction(action + this.ffRwdSpeed[this.seekMultiplier], this._getActionKey());

        // if (!this.tag("FTVideoComponent").paused && !this.tag("FTVideoComponent").ended) {
        //     this.tag("FTVideoComponent").pause();
        // }
    }


    $search(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        Logger.processUserAction('showSearchPageOnPlayerUI', this._getActionKey());
        this.stopFFREWTimer();
        const { appState, appConfig } = AppData as AppSetup;
        const app: AppModel = appState?.getApp()!;
        app.navigation.setCurrentPlayingTime(this.currentTimeExit);
        appState.player.videoStartedFromResumePoint = this.currentTimeExit;
        appState.player.pausedTime = this.currentTimeExit;
        this.closeVideo(true) //XFIN - 692 - shouled not trigger the close tracker when navigating to search.
        appConfig.searchInput = appConfig.defaultSearchInput
        appConfig.useHistory = false;
        /** Fix for XFIN-832 - START */
        if (Math.abs(this.seekMultiplier) > 0) {
            this.stopFFREWTimer();
            this.tag("FTTrickPlayUI").hide();
            this.updateWatchNextThumbPosition();
        }
        /** Fix for XFIN-832  - END */
        Router.navigate("search-screen/player", false);
    }

    $info(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        this.tag('ItemInfo').item = this.videoInfo
        /** Fix for XFIN-832 - START */
        if (this._rowIndex == 2) {
            return;
        }
        /** Fix for XFIN-832 - END */
        if (!this.isInfoOn()) {
            this.hideController()
            this.tag('WatchNextThumb').visible = false;
            Logger.processUserAction('showInfoWindowOnPlayerUI', this._getActionKey());
            this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$info']
            // changed the code due to animation delay on set the visibility as focus as stuck at Info which triggers the loop to show hide it.
            this.tag("ItemInfo").show()
            this._setState('ItemInfoState')
            /** Fix for XFIN-832 - START */
            this.tag("FTTrickPlayUI").hide();
            if (Math.abs(this.seekMultiplier) > 0) {
                this.$playPause();
            }
            /** Fix for XFIN-832  - END */
            //this._refocus()
        } else {
            this.showController()
            this.tag('WatchNextThumb').visible = true;
            this.updateWatchNextThumbPosition();
            Logger.processUserAction('hideInfoWindowOnPlayerUI', this._getActionKey());
            // changed the code due to animation delay on set the visibility as focus as stuck at Info which triggers the loop to show hide it.
            //this.tag("ItemInfo").hide()
            this._setState('')
            this._refocus()
        }

    }

    /**
     * isInfoOn -  returns if the info is displayed or not.
     * changes this code to get the alpha value to boolean value
     * introduced a paraneter in PlayerInfo component.
     *
     * @returns {Boolean}
     */
    isInfoOn() {
        return this.tag("ItemInfo").isVisible;
    }


    $closedcaption(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        if (Math.abs(this.seekMultiplier) > 0) {
            this.$playPause();
        }
        this.hideController()
        this.tag("FTTrickPlayUI").hide();
        this._setState('CCSettingsState')
        
    }

    $closeCCOverlay() {
        this._setState('')
    }

    $ccToggle(state: any) {
        this.showCC = state
        const popupText = this.showCC ? "Subtitle On" : "Subtitle Off";
        this.showSubtitlePopup(popupText);
        if (this.showCC) {
            Logger.processUserAction("closedCaptionsShown", this._getActionKey());
        } else {
            Logger.processUserAction("closedCaptionsHidden", this._getActionKey());
        }
        this.showHideSubtitleState(state)
    }

    _updateProgress(cur, dur) {
        const progress = cur / dur
        const currentText = Helper.secondsToDisplayReadyTime(cur || 0)
        const duration = Helper.secondsToDisplayReadyTime(dur || 0)
        const timeObj = {
            Controls: {
                ProgressWrapper: {
                    TimeWrapper: {
                        CurrTime :{
                            text: { text: currentText}
                        },
                        DurationTime: {
                            text: { text: duration}
                        }
                    },
                    ProgressBarInteraction: {
                        ProgressDragIcon : {
                            x: (1920 - 400) * progress
                        }
                    },
                    Progressbar: {
                        progress: progress
                    }
                }
            }
        }
        this.tag('ControlWrapper').patch(timeObj)
    }

    $ItemChanged() {
        this._index = this.tag('MediaButtons').selectedIndex
        //this.showController()
    }

    $ItemSelected(action) {
        if (this.playerState === PLAYERSTATE.NONE) {
            return;
        }
        this[action](true)
    }

    _addControlButtons() {
        const { appConfig } = AppData as AppSetup;
        // this._index = 2;
        this.focusedRowIndex = 1;
        const buttons = Helper.buttons
        this.buttonIndexMapper = {};
        const items: any[] = []
        buttons.map((button, index) => {
            if (button.action == '$closedcaption' && appConfig?.disableCC) return
            this.buttonIndexMapper[button.action] = index;
            items.push({
                type: ControlIcon,
                x: (button.x) - button.iconWidth / 2,
                y: (button.y) - button.iconHeight / 2,
                collision: true,
                w: button.iconWidth,
                h: button.iconHeight,
                color: 0x000000,
                icons: button.iconsvg,
                sprite: button.sprite,
                action: button.action,
                tts: button.tts
            })
        })

        this.tag('MediaButtons').items = items
        this.tag('MediaButtons').selectedIndex = 3
    }

    override _getFocused() {
        if (this.focusInfo[this.focusedRowIndex] == "playlist") {
            this.FocusElement = this.tag("VideoPlayList");
        } else if (this.focusInfo[this.focusedRowIndex] == "control") {
            if (this.controllerOn) {
                this.FocusElement = this.tag('MediaButtons')
            } else {
                this.FocusElement = this
            }
        } else if (this.focusInfo[this.focusedRowIndex] == "skip") {
            return this.tag("SkipTitles");
        } else if (this.focusInfo[this.focusedRowIndex] == "watch_next") {
            return this.tag("WatchNextThumb");
        } else if (this.focusInfo[this.focusedRowIndex] == "trickplay") {
            this.tag("FTTrickPlayUI").show(true);
            this.updateWatchNextThumbPosition();
            this.FocusElement = this.tag("FTTrickPlayUI");
        } else {
            this.FocusElement = this.tag('MediaButtons')
        }
        Log.info('_getFocused :', this.FocusElement)
        return this.FocusElement
    }

    /**
     * @method $skipAction
     * @description Handler for skip intro or skip credit button press. 
     * It will update the current time to intro end time or credit time accordingly.
     * It will capture the User logs also.
     * @param - NA
     * @returns - NA.          
    */
    $skipAction() {
        this.checkOnce = false;
        let videoInfo = this.videoInfo;
        var curTime = Math.round(this.getCurrentTime());
        this.showSkip = false;
        // this._rowIndex = 1;
        this.focusedRowIndex = 1;
        this.showSkipButton(false);  // Fix for delay in skip button hidding after clicking
        this.showController()        // Fix for delay in skip button hidding after clicking
        if (curTime > videoInfo.intro_st && curTime <= videoInfo.intro_et) {
            Logger.processUserAction('skipIntroButtonPressedOnVideoPlayer_SkippingIntro', this._getActionKey())
            this.setCurrentTime(videoInfo.intro_et + 1);
            // setTimeout(() => {
            //     this.showController();
            // }, 1000);
        } else {
            if (curTime > videoInfo.endcredit_st && curTime <= videoInfo.endcredit_et) {
                Logger.processUserAction('skipCreditButtonPressedOnVideoPlayer_WatchingCredits', this._getActionKey())
                this.clearWatchNextTimer();
                this.hideController();
                this.tag('WatchNextThumb').visible = false;
                this.creditsWatched = true;
                //this.setCurrentTime(videoInfo.endcredit_et + 1);
            }
        }
        // this.tag('MediaButtons').selectedIndex = 2;
        if (this.playerState == PLAYERSTATE.PAUSED) {
            this.ftStreamingPlayer.play()
        }
        //this.showSkipButton(false);
        // this._refocus();
        // XFIN-1270 //
        this.clearControllerTimeout();
        this.controlHideIntv = Registry.setTimeout(() => {
            this.hideController();
        }, 10000);
        // XFIN-1270 //
    }

    showSubtitlePopup(text: string) {
        this.tag('VideoCCOnOffText').patch({
            visible: true,
            text: { text: text }
        });
        if (this.subtitlePopupTimeoutId) {
            clearTimeout(this.subtitlePopupTimeoutId);
        }
        this.subtitlePopupTimeoutId = setTimeout(() => {
            this.tag('VideoCCOnOffText').visible = false;
            this.subtitlePopupTimeoutId = null;
        }, 1000);
    }

    /**
     * @method $watchNextAction
     * @description Handler for Watch Next thumbnail click action.
     * It will navigate to the next video immediately and clear any existing timers.
     * 
     */
    $watchNextAction() {
        if (this.isNavigatingToNextVideo) return;
        this.isNavigatingToNextVideo = true;
        this.clearWatchNextTimer();
        this.checkOnce = false;
        this.showSkip = false;
        Logger.processUserAction('clickedNextVideoPreview', this._getActionKey())
        this.$next()

        setTimeout(() => {
            this.isNavigatingToNextVideo = false;
        }, 1500);
    }

    /**
     * @method watchNextTimer
     * @description Starts a timer to automatically navigate to the next video.
     * This function sets a timeout of 10 seconds, after which it logs the user action.
     *
     */
    watchNextTimer() {
        clearTimeout(this.watchNextTimeOut);
        this.watchNextTimeOut = setTimeout(() => {
            Logger.processUserAction('clickedNextVideoPreview', this._getActionKey())
            this.$next()
        }, 10000);
    }

    clearWatchNextTimer() {
        if (this.watchNextTimeOut) {
            clearTimeout(this.watchNextTimeOut);
        }
        this.watchNextTimerStarted = false;
        this.tag('WatchNextThumb').pauseProgress();
    }

    /**
    * @method preloadNextItemImage
    * @description Preloads the next item's image to be displayed in the Watch Next thumbnail.
    * This function checks if the next item image URL is already set, and if not, it fetches the next item.
    * @param retryCount - Number of retries to preload the image, defaults to 0.
    */
    preloadNextItemImage = async (retryCount = 0) => {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();

        // Only preload if not already loaded
        if (!this.nextItemImageUrl) {
            const nextItem = await app?.findNextItem();
            if (nextItem) {
                this.nextItemImageUrl = nextItem.bg_image_landscape;
            }
            if (!this.nextItemImageUrl && retryCount < 10) {
                // Retry after 2000ms if image not available
                // This is to handle cases for dynid where the next item is immediately available
                this.preloadNextItemTimer = setTimeout(() => {
                    this.preloadNextItemImage(retryCount + 1);
                }, 2000);
            }
        }
    };

    /**
     * @method updateWatchNextThumbPosition
     * @description Updates the position of the Watch Next thumbnail based on the visibility of the TrickPlay UI.
     * If TrickPlay is visible, the Watch Next thumbnail is moved up; otherwise, it is positioned lower on the screen.
     */
    updateWatchNextThumbPosition() {
        // If TrickPlay is visible, move WatchNextThumb up
        if (this.tag("FTTrickPlayUI").visible) {
            this.tag("WatchNextThumb").y = 345;
        } else {
            this.tag("WatchNextThumb").y = 1080 - 530;
        }
    }

    /**
     * @method updateSkipIntroAndCredits
     * @description Handler to display skip intro or credit based on the video current time.      
     * @param curTime - video current playhead time
     * @returns - NA.          
    */
    updateSkipIntroAndCredits = (curTime: any) => {
        const { appState } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig()
        const resumeVidMinDuration = appApiConfig?.appConfig?.resumeVidMinDuration
        let videoInfo = this.videoInfo;

        if (videoInfo.intro_et || videoInfo.endcredit_st) {   //Added videoInfo.endcredit_st  to show Play Next if intro_et  not available
            // Prevent showing credits button if already watched/skipped
            if (this.creditsWatched && videoInfo.endcredit_st && curTime >= videoInfo.endcredit_st && curTime <= videoInfo.endcredit_et) {
                this.tag('WatchNextThumb').visible = false;
                this.disableSkip();
                this.clearWatchNextTimer();
                return;
            }
            if ((videoInfo.intro_et && curTime > videoInfo.intro_st && curTime <= videoInfo.intro_et) || (videoInfo.endcredit_st && curTime >= videoInfo.endcredit_st && curTime <= videoInfo.endcredit_et)) {
                if (videoInfo.endcredit_st && curTime >= videoInfo.endcredit_st && curTime <= videoInfo.endcredit_et) {
                    this.tag('SkipTitles').label = 'WATCH CREDITS';
                    this.tag('SkipTitles').x = 1920 - 500;
                    this.tag('SkipTitles').w = 300;
                    if (!this.hideControlsOnPlayNext) {   //Fix for XFIN-1159
                        this.showController(false);
                        if (!this.watchNextTimerStarted) { // Only start timer once
                            if (this.nextItemImageUrl) {
                                this.tag('WatchNextThumb').imgSrc = this.nextItemImageUrl;
                            }
                            this.tag('WatchNextThumb').visible = true;
                            this.updateWatchNextThumbPosition();
                            this.watchNextTimer();
                            this.watchNextTimerStarted = true;
                        }
                        this.tag('WatchNextThumb').startProgress();
                    }
                }
                if (videoInfo.intro_et && curTime > videoInfo.intro_st && curTime <= videoInfo.intro_et) {
                    this.tag('WatchNextThumb').visible = false
                    this.tag('SkipTitles').label = 'SKIP INTRO';
                    this.tag('SkipTitles').x = 200;
                    this.tag('SkipTitles').w = 220;
                }
                this.showSkipButton(true);
                this.enableSkip = true;
                this.focusFirstTime();
                this.clearControllerTimeout();
            } else {
                this.tag('WatchNextThumb').visible = false;
                this.disableSkip();
                this.clearWatchNextTimer();
                this.hideControlsOnPlayNext = false;
            }
        } else if (videoInfo.menudisplay_st) {     //XFIN-1121
            if ((videoInfo.menudisplay_st && curTime >= videoInfo.menudisplay_st && curTime <= videoInfo.runtime && (resumeVidMinDuration && videoInfo.runtime > resumeVidMinDuration))) {    //XFIN-1121 menu auto-display condition
                if (!this.hideControlsOnPlayNext) {     //Fix for XFIN-1159
                    this.showController(false);
                    this.clearControllerTimeout();
                }
            } else {
                this.hideControlsOnPlayNext = false;
            }
        }

    }

    /**
     * @method disableSkip
     * @description Handler to disable skip action.      
     * @param - NA.          
     * @returns - NA.          
    */
    disableSkip = () => {
        if (this.checkOnce) {
            this.hideController();
        }
        this.enableSkip = false;
        this.showSkip = false;
        this.checkOnce = false;
        this.showSkipButton(false);
    }

    /**
     * @method showSkipButton
     * @description Handler to control the visibility status of skip button.
     * @param visible - true or false whether display the skip button or not.
     * @returns - NA.          
    */
    showSkipButton = (visible: any) => {
        this.tag('SkipTitles').visible = visible
    }

    /**
     * @method focusFirstTime
     * @description Handler to focus the skip button when it is displayed.
     * @param - NA.
     * @returns - NA.
    */
    focusFirstTime = () => {
        if (this.checkOnce) {
            return;
        }
        this.updateFocusInfo("")
        this.checkOnce = true;
        this.showSkip = true;
        if (this.tag('WatchNextThumb').visible && this.tag('SkipTitles').visible && this.tag('SkipTitles').label === 'WATCH CREDITS') {
            this.focusedRowIndex = 3;
        } else if (this.tag('SkipTitles').visible && this.tag('SkipTitles').label === 'SKIP INTRO') {
            this.focusedRowIndex = 2;
        }
        this._refocus();
    }

    /**
     * @method setCurrentTime
     * @description Handler to set the current time of the video.
     * @param currentTime - current time of the video.
     * @returns - NA.          
    */
    setCurrentTime = (currentTime: any) => {
        if (this.videoEl) {
            this.videoEl.currentTime = currentTime;
        }
    }

    /**
     * @method getCurrentTime
     * @description Returns the current time of the video.
     * @param - NA.
     * @returns currentTime - current time of the video.          
    */
    getCurrentTime = () => {
        if (this.videoEl) {
            return this.videoEl.currentTime;
        }
        return 0;
    }

    handleAppSuspend() {
        this.closeVideo()
    }

    handleAppResumed() {
        this._active()
    }

    /**
     * @method handleInactiveEvent
     * @description Handler for inactive lifecycle event.
     * @param - NA.
     * @returns - NA.          
    */
    handleInactiveEvent() {
        if (this.playerState == PLAYERSTATE.PLAYING) {
            this.ftStreamingPlayer.pause()
        }
        this.closeVideo()
        this.handleBackNavigation()
    }

    handleBackNavigation() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.closeVideo()
        setTimeout(() => {
            app?.handleBackNavigation();
        }, 100);
    }



    /**ADS */
    checkForAds = (adtype = 'all', resumeTime: any) => {
        const { appConfig, appState } = AppData as AppSetup
        Logger.printLog('info', 'checkForAds called... disableAds ', appConfig.disableAds);
        Logger.printLog('info', 'checkForAds called... adSdkToUse ', appConfig.adSdkToUse);
        const app = appState?.getApp();
        let ads = app?.ads;
        let adHandler = app.adHandler;
        let freeWheelAds = app?.freeWheelAds;
        freeWheelAds.breakPosition = 0;
        if (appConfig.disableAds == false) {
            if (appConfig.enableMidrolls == true) adHandler.getCuePoints(this.videoInfo);
            // if (ads.preRollRequestMade || (appState.player.videoStartedFromResumePoint !== 0 && appConfig.adSdkToUse == 'ima')) {
            //     this._resumePlayer(resumeTime);
            //     return;
            // }
            // ads.preRollRequestMade = true;            
            if (appConfig.adSdkToUse == 'ima' && appConfig.disableAds == false) {
                app.imaAdHandler.requestAds(this.videoInfo, adtype);
            } else {
                let testInfo = appConfig?.testInfo;
                if (freeWheelAds) {
                    if (freeWheelAds.player) {
                        freeWheelAds.player.cleanUp();
                    }
                    this.screen = 'ad';
                    freeWheelAds.initAds(false, this.videoInfo, this);
                } else {
                    this._resumePlayer(resumeTime);
                }
            }
        } else { // no ads to be played, hence start playback
            this._resumePlayer(resumeTime);
        }
    }

    isPaused = () => {
        let paused = false;
        if (this.videoEl?.paused) {
            paused = this.videoEl?.paused;
        }
        return paused;
    }

    resumeVideoPlayback = (startTime: any, callingMethod = '') => {
        Logger.printLog('info', 'resumeVideoPlayback called... ' + startTime);
        this.screen = 'player';
        const { appConfig, appState } = AppData as AppSetup
        if (this.isPausedOnAd) {
            Logger.processUserAction('adBreakEnd', startTime);
        }
        this.isPausedOnAd = false
        if (appConfig?.adSdkToUse == 'freewheel') {
            if (appConfig.enableWaterfalling) {
                this.resetIma();
            }
        }
        if (appConfig?.testEnableNativePlayer == true) {
            if (startTime > 0 && this.isPlayerEnabled()) {
                this.showVideo();
                this.ftStreamingPlayer.play();
                this.setPlayerState(PLAYERSTATE.PLAYING);
            } else {
                this._resumePlayer(startTime);
            }
        } else {
            this._resumePlayer(startTime);
        }
    }

    isPlayerEnabled=() => {
        if(this.ftStreamingPlayer && this.ftStreamingPlayer.src && this.ftStreamingPlayer.src.length >0  && this.ftStreamingPlayer.videoEl && this.ftStreamingPlayer.videoEl.src){
            return true;
        }
        return false;
    }

    removeEventListeners = () => {
    }

    $videoPlayerLoadingState(loadState: boolean) {
        this.showHideVideoLoading(loadState)
    }

    $videoPlayerTimeUpdate(curTime: any) {
        const { appConfig, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let ads = app?.ads;

        if (appConfig.enableMidrolls == true) {

            if (appConfig.disableAds == false) {

                if (Helper.isFusePrefetchEnabled()) {
                    this.checkAndPrefetch(curTime)
                }
            }

            if ($.inArray(curTime, ads.currentVodCuePoints) !== -1) {
                Logger.printLog('info', 'onEventVideoTimeUpdate >> matched with a cuepoint at ' + curTime, "");
                appState.player.pausedTime = curTime;
                if (appConfig.adSdkToUse == 'freewheel' && ads.midAdPlaying == false) {
                    let freeWheelAds = app?.freeWheelAds;
                    if (!Helper.isFusePrefetchEnabled()) {
                        //Prefetch of freewheel and ima-fallback - existing workflow
                        freeWheelAds.breakPosition++;
                        freeWheelAds.requestAdsCustom(this);
                    } else {
                        //[FUSE PREFETCH] Freewheel prefetch is already done and just fallback to ima
                        var cuePointTime = curTime;
                        if (appConfig.prefetchAds) {
                            cuePointTime = cuePointTime + appConfig.prefetchTiming;
                        }
                        //this.$playPause();
                        if (freeWheelAds.noAds > 0) {
                            freeWheelAds.requestFallbackIma(this.videoInfo, freeWheelAds.noAds, cuePointTime);
                        }
                    }
                }
                ads.currentVodCuePoints.splice($.inArray(curTime, ads.currentVodCuePoints), 1);
            } else if (appConfig.prefetchAds && $.inArray(curTime, ads.currentVodPlayPoints) !== -1) {
                appState.player.pausedTime = curTime;
                if (appConfig.adSdkToUse == 'freewheel' && ads.midAdPlaying == false) {
                    let freeWheelAds = app?.freeWheelAds;
                    freeWheelAds.player.playMidroll();
                }
                ads.currentVodPlayPoints.splice($.inArray(curTime, ads.currentVodPlayPoints), 1);
            }

            if (appConfig.adSdkToUse == 'ima' && appConfig.useVmap == false && appConfig.disableAds == false) {
                if (app.imaAdHandler.cuePointsManager != null) {
                    app.imaAdHandler.cuePointsManager.updateCurrentTime(curTime);
                }
            }
        }
        this.updateSkipIntroAndCredits(curTime);
    }
    screen = "";
    prefetched = new Set();

    /**
     * Checks if the current playback time has reached a prefetch trigger point for upcoming ads,
     * and initiates a prefetch request if conditions are met.
     *
     * This method compares the current time against pre-defined prefetch (PF) points and cue points.
     * If the current time is within the prefetch window and the ad hasn't been prefetched yet,
     * it triggers the appropriate prefetch logic based on the configured ad SDK (IMA or Freewheel).
     *
     * @param {number} curTime - The current playback time in seconds.
     *     
     * Behavior:
     * - For IMA: Uses `cuePointsManager.requestFusePrefetch(playTime)` to prefetch the ad.
     * - For Freewheel: Updates ad state and calls `requestPrefetchAds`.
     * - Ensures only one prefetch is triggered per matching PF time using `this.prefetched` set.
     */
    checkAndPrefetch(curTime) {
        const { appConfig, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let ads = app?.ads;
        for (let i = 0; i < ads.currentVodPFPoints.length; i++) {
            const pfTime = ads.currentVodPFPoints[i];
            const cueTime = ads.currentVodCuePointsCopy[i];

            // Check if current time is between PF and Cue point and hasn't been prefetched yet
            if (curTime >= pfTime && curTime < cueTime && !this.prefetched.has(pfTime)) {
                //this.$playPause();
                this.prefetched.add(pfTime);
                // Make your prefetch request here
                Logger.printLog('info', `[FUSE PREFETCH] Prefetching ad for cue at ${cueTime}, triggered at ${curTime}`, "");
                if (appConfig.adSdkToUse == 'ima') {
                    let playTime = ads?.currentVodPFInfo[pfTime].playTime
                    if (app.imaAdHandler.cuePointsManager != null) {
                        app.imaAdHandler.cuePointsManager.requestFusePrefetch(playTime);
                    }
                }
                if (appConfig.adSdkToUse == 'freewheel' && ads.midAdPlaying == false) {
                    let freeWheelAds = app?.freeWheelAds;
                    appState.player.pausedTime = cueTime;
                    freeWheelAds.breakPosition++;
                    freeWheelAds.isFusePF = true;
                    freeWheelAds.pfTime = pfTime;
                    freeWheelAds.requestPrefetchAds(this, pfTime);
                }
                break; // Stop after the first match
            }
        }
    }

    pauseContent() {
        const { appState, appConfig } = AppData as AppSetup;
        this.screen = "ad";
        this._refocus();
        this.isPausedOnAd = true
        Logger.processUserAction('adBreakStart', appState.player.pausedTime);
        if (appConfig?.testEnableNativePlayer) {
            this.ftStreamingPlayer.pause()
            this.hideVideo()
            this.setPlayerState(PLAYERSTATE.NONE);
        } else {
            try {
                this.resetPlayer();
                //this.tag("FTPlayer").pauseContent();
                //this.tag("FTPlayer").hideVideo();
            } catch (e) {
            }
        }
    }

    playContent() {
        this.screen = 'player';
        //this.tag("FTPlayer").playContent();
    }
    hideLoader() {
        //this.tag("Loader").hideLoader();
    }
    showLoader() {
        //this.tag("Loader").showLoader();
    }

    resetAds() {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp();
        let freeWheelAds = app?.freeWheelAds;
        if (freeWheelAds && freeWheelAds.player) {
            freeWheelAds.breakPosition = 0;
            freeWheelAds.player.onContentVideoEnded();
        }
        this.resetIma();
    }

    resetIma() {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp();
        this.isPausedOnAd = false
        if (app.imaAdHandler) {
            app.imaAdHandler.resetIma();
        }
    }


    static override _states(): any[] {
        return [
            class ItemInfoState extends this {
                override $enter(event: any) {
                    this.tag("TitleContainer").setSmooth('alpha', 0)
                    this.tag("ItemInfo").show()
                }
                override $exit(event: any) {
                    this.tag("TitleContainer").setSmooth('alpha', 1)
                    this.tag("ItemInfo").hide()
                }
                override _getFocused() {
                    this.tag('ItemInfo')
                }
                override _handleBack(e: KeyboardEvent): boolean | void {
                    //this.tag('ItemInfo').hide()
                    this._setState('');
                }
                _handleClick(target) {
                    if (target.ref == 'BackButton') {
                        this._setState('');
                    }
                }
                override _handleKey(e: KeyboardEvent): boolean | void {
                    if (e.keyCode == KeyCodes.KEY_EXIT) {
                        return this._handleExitKey()
                    }
                    return true
                }
            },
            class CCSettingsState extends this {
                override $enter(event: any) {
                    this.tag('CCSettingsOverlay').visible = true
                    this.tag('CCSettingsOverlay').setSmooth('alpha', 1)
                    this.tag("TitleContainer").setSmooth('alpha', 0)
                    Logger.processUserAction("ccSettingsOverlayOpened", this._getActionKey());
                }
                override $exit(event: any) {
                    this.tag('CCSettingsOverlay').visible = false
                    this.tag('CCSettingsOverlay').setSmooth('alpha', 0)
                    this.tag("TitleContainer").setSmooth('alpha', 1)
                    Logger.processUserAction("ccSettingsOverlayClosed", this._getActionKey());
                }
                override _getFocused() {
                    return this.tag('CCSettingsOverlay')
                }
                override _handleBack(e: KeyboardEvent): boolean | void {
                    this.$closeCCOverlay();
                }
                override _handleKey(e: KeyboardEvent): boolean | void {
                    if (e.keyCode == KeyCodes.KEY_EXIT) {
                        return this._handleExitKey()
                    }
                    return true
                }
                override _handleClick(target: any) {
                    if (target.ref == 'BackButton') {
                        this.$closeCCOverlay();
                    }
                }
            }
        ]
    }

    _handleExitKey() {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        this.stopFFREWTimer(); // added for the fix XFIN-681
        this.hitCloseTracker();
        app?.handleAppExit()
        return true
    }

    override _detach() {
        this.stage.gc(false)
        if (this.errorNextItemTimer) {
            clearTimeout(this.errorNextItemTimer);
            this.errorNextItemTimer = null;
        }
        if (this.preloadNextItemTimer) {
            clearTimeout(this.preloadNextItemTimer);
            this.preloadNextItemTimer = null;
        }
    }


    _handleClick(target) {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        if (target.action) {
            this[target.action](true, false);
        } else if (target.ref == 'BackButton') {
            this.handleBackNavigation();
        } else if (target.ref == 'Container') {
            this.showController()
        }

    }

    _handleDrag(details, component) {
        
        if(component && component.__ref == "ProgressDragIcon") {
            this._updateProgressButtonPosition(details,component)
        }
    }

    _updateProgressButtonPosition(details, component) {
        const buttonComp = this.tag('ProgressDragIcon')
        const parentComp = this.tag('ProgressBarInteraction')
        const endX = details.position.x
        const delta = (endX) * (app.application.stage.w / window.innerWidth)
        const plotPos = Math.min(Math.max(delta-200,0), 1920-400) //Math.min(Math.max((buttonComp.x + delta),0),parentComp.w-50)
        Log.info('Video Drag : ', [endX, delta])
        buttonComp.patch({
            x: plotPos
        })
        this.startDragTimeout()
    }

    dragTimerId:any = null
    isDragging:boolean = false
    startDragTimeout() {
        this.stopDragTimeout()
        this.showController(false)
        this.isDragging = true
        this.dragTimerId = setTimeout(()=>{
            this.stopDragTimeout()
        },1000)
    }
    stopDragTimeout() {
        clearTimeout(this.dragTimerId)
        this.dragTimerId = null
        this.isDragging=false
        this.showController(true)
        const buttonComp = this.tag('ProgressDragIcon')
        const perc = buttonComp.x / (1920-400)
        const videoPos = Math.min(Math.round(this.videoEl.duration*perc),this.videoEl.duration-10)
        Log.info('Video Drag Stop: ', perc, videoPos)
        this.setCurrentTime(videoPos)
    }
    // _handleHover(target) {
    //     console.log('VideoScreen Hover: ', target.ref)
    //     //this._focus()
    //     //this.fireAncestors('$handleHover', target)
    // }

    // _handleUnhover(target) {
    //     console.log('VideoScreen Unhover ', target)
    //     //this._unfocus()
    // }
    /**ADS */
}
